import React from 'react'
import { withRouter } from 'react-router-dom';
import InpatientList from "../../../component/sysadmin/inpatient/inpatient_list";
import InpatientListSearch from "../../../component/sysadmin/inpatient/inpatient_list_search";

class InpatientListPage extends React.Component {

    render() {
        return (
            <>
                <InpatientListSearch />
                <InpatientList />
            </>
        )
    }

}

export default withRouter(InpatientListPage);